import React from 'react';
import { deepCopy } from '@pascal/pascal-core';

export const RangeBtnValues = ({
  setRangeValues,
  changeRangeSelected,
  rangeSelectedBtnValues,
  selectedRangeValues = [],
}) => {
  return (
    <div className='w-md-bet-variants'>
      <div className='w-md-bet-var-btns'>
        {rangeSelectedBtnValues.map(({ id, from, to }) => {
          const selected = selectedRangeValues.find((item) => item.from <= from && item.to >= to);
          return (
            <button
              key={id}
              onClick={() => {
                changeRangeSelected(id, from, to);
              }}
              type='button'
              className={`w-md-bet-num ${selected ? 'active' : ''}`}
            >
              <span className='md-calc-variant-text'>
                {from} - {to}
              </span>
            </button>
          );
        })}
        <button
          type='button'
          className='w-md-bet-reset-btn'
          onClick={() => {
            setRangeValues(deepCopy([]));
          }}
        >
          <i className='ui-lib-resset' />
        </button>
      </div>
    </div>
  );
};
